var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"instantwin_message_history"},[_c('message-history',{attrs:{"campaign":_vm.campaign}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }